import { Button, Box, TextField } from "@mui/material";
import React from "react";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";

export default function NrAnglers(props) {
  console.log("NrAnglers", props);
  const { preferences, trip_type } = props;
  const uniquePreferences =
    !preferences || !Array.isArray(preferences) || preferences.length === 0
      ? []
      : [
          ...preferences
            .reduce(
              (nanglers, obj) => nanglers.set(obj.nanglers, obj),
              new Map()
            )
            .values(),
        ];
  return (
    <Box mt={0} width="100%" align="center">
      <h2 className="sectionTitle center">Number of Anglers</h2>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md="auto">
          <Box display="flex" flexWrap="wrap" justifyContent="center">
            {uniquePreferences.map(
              (trip, idx) =>
                trip_type === trip.tripcatg && (
                  <Box key={idx} m={0.5}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className="form-input"
                      data-new-value={trip.nanglers}
                      data-field={"number_of_anglers"}
                      size="large"
                      onClick={(e) =>
                        props.handleTripPreferenceChange(e, trip.nanglers)
                      }
                      key={trip.nanglers + trip.tripcatg}
                    >
                      {trip.nanglers}
                    </Button>
                  </Box>
                )
            )}
          </Box>
        </Grid>

        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              label="Number of Anglers:"
              className="number-of-input"
              inputProps={{ min: 0, style: { textAlign: "center" } }}
              value={
                props.number_of_anglers ? Number(props.number_of_anglers) : ""
              }
              name="number_of_anglers"
              type="number"
              min="0"
              max="999"
              onChange={(e) => props.handleInputChange(e)}
              helperText="Must be greater than zero"
            />
          </FormControl>
          <HelpText helpText={getHelpText(props.helpText, "nanglers")} />
        </Grid>
      </Grid>
    </Box>
  );
}
